



























































import Vue, { PropType } from 'vue';
import ComponentSelectCharacter from './SelectCharacter.vue';

export interface Hero {
  name: string;
  speed: number;
  crBonus: number;
  crPush: number;
  crPushAlly: number;
  speedDown: boolean;
}

export default Vue.extend({
  components: {
    SelectCharacter: ComponentSelectCharacter,
  },
  props: {
    hero: Object as PropType<Hero>,
  },
});
